const rawBase = (import.meta.env.VITE_API_BASE_URL as string | undefined)?.trim();

export const API_BASE = rawBase && rawBase.startsWith('http') ? rawBase : 'http://localhost:4040';
export const AUTH0_DOMAIN = (import.meta.env.VITE_AUTH0_DOMAIN as string | undefined)?.trim() || '';
export const AUTH0_CLIENT_ID = (import.meta.env.VITE_AUTH0_CLIENT_ID as string | undefined)?.trim() || '';
export const AUTH_AUDIENCE = (import.meta.env.VITE_AUTH0_AUDIENCE as string | undefined)?.trim() || '';
